module.exports = __webpack_public_path__ + "static/media/plusicon.348e6478.PNG";